export class RolesData {
  id: number;
  role: string;
  unit: string;
  isActive: boolean;
  createdAt?: Date;
  createdUser?: string;
  updatedAt?: Date;
  updatedUser?: string;
  versionFlag?: number;

  constructor(
    id: number,
    role: string,
    unit: string,
    isActive: boolean,
    createdAt?: Date,
    createdUser?: string,
    updatedAt?: Date,
    updatedUser?: string,
    versionFlag?: number
  ) {
    this.id = id;
    this.role = role;
    this.unit = unit;
    this.isActive = isActive;
    this.createdAt = createdAt;
    this.createdUser = createdUser;
    this.updatedAt = updatedAt;
    this.updatedUser = updatedUser;
    this.versionFlag = versionFlag;
  }
}
